module.exports = __webpack_public_path__ + "static/img/l2.18227af3.png";